import React from 'react';

import CenteredCardPage from '@/ui/components/CenteredCardPage/CenteredCardPage';

import type { Props } from './types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const NotAuthorized = ({ heading, message }: Props) => {
  return (
    <CenteredCardPage
      heading={heading || 'Not Authorized'}
      message={message || 'You do not have permission to view this page.'}
    />
  );
};
export default React.memo(NotAuthorized);
